import React from 'react';
import { NestedRouter } from 'src/router';
import { routes } from './routes';

function SolutionDevices() {
  return <NestedRouter routes={routes} />;
}

export default SolutionDevices;
